import { useAppQuery } from "~/hooks/useAppQuery"
import { getMembers } from "../server/catalog.functions"
import { catalogMembersQueryKey } from "../query-keys"

export function useMembers() {
  return useAppQuery({
    queryKey: catalogMembersQueryKey(),
    queryFn: () => getMembers(),
    errorMessage: "Не удалось загрузить экспертов",
  })
}
